module.exports = __webpack_public_path__ + "media/images/full_space-ee7f0111c38e3b0bcb5e6130b9cf5635.svg";